<template>
  <div class="mt-3">
    <b-form>
      <b-row>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Group Name</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input
                :state="groupNameStatus"
                v-model="groupsForm.groupName"
                :tagValidator="groupNameStatus"
            ></b-form-input>
              <template #description>
                <div v-if="!groupNameStatus" id="tags-validation-help">
                  Names can not contain spaces or these special  characters {{String(invalidChars)}}
                </div>
              </template>
          </b-form-group>
        </b-col>
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">Group Description</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input
                v-model="groupsForm.description"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
          Close
        </base-button>
        <base-button type="primary" title="Save"  v-on:click="createGroupSubmit" :loading="submitLoading">
            Submit
        </base-button>
      </div>

    </b-form>
  </div>
</template>

<script>
import administratorService from "../../common/api-services/administrator-service";
import handleResponse from "../../common/directive/handlResponse";

export default {
  name: "Groups-Create",
  components: {},
  computed: {
    groupNameStatus() {
      for (let i in this.groupsForm.groupName) {
        if (this.invalidChars.includes(this.groupsForm.groupName[i])) {
          return false
        } else if (this.groupsForm.groupName[i] === ' ') {
          return false
        }
      }
      return this.groupsForm.groupName.length > 0
    }
  },
  data() {
    return {
      groupsForm: {
        groupName: '',
        description: '',
      },
      submitLoading: false,
      invalidChars: ['{', '}', '\\', '/', ':', '*', '?', '"', '<', '>', '|']
    }
  },
  methods: {
    modalClose() {
      this.$bvModal.hide('groups-create-new')
    },

    createGroupSubmit() {
      if (this.groupNameStatus) {
        this.submitLoading = true;
          this.modalClose();
        administratorService.createGroup(this.groupsForm).then(res => {
          let {type, msg} = handleResponse.apiResponse(res);
          this.$toast(msg, {type: type})
          setTimeout(() => {
            this.$root.$emit('createNewGroup')
          }, 1000)
        })
      }
    },
  }
}
</script>
